import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

interface CategoryGridProps {
  category: string;
}

export default function CategoryGrid({ category }: CategoryGridProps) {
  const filteredComics = comics.filter((c) => c.category === category);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            {category}韩漫作品
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            共 {filteredComics.length} 部作品，持续更新中
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {filteredComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫网${category}韩国漫画`}
                  title={`${comic.title} - 韩漫网免费韩漫在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                    comic.status === "连载中"
                      ? "bg-accent-500 text-white"
                      : "bg-foreground-600 text-white"
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 text-center truncate whitespace-nowrap">
                {comic.title}
              </h3>
              <div className="flex items-center justify-center gap-1.5 mt-1">
                <span className="text-accent-500 font-bold text-xs">{comic.rating}</span>
                <span className="text-foreground-400 text-xs">{comic.views}</span>
              </div>
              <p className="text-xs text-foreground-400 text-center mt-1">
                更新至 {comic.latestChapter}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}